import Container from "./Container";

const isArray = Array.isArray;

const copyObject = function(obj) {
    const result = {};

    Container.forEach(obj, function(value, key) {
        if (isArray(value)) {
            result[key] = value.slice(0, value.length);
        } else {
            result[key] = value;
        }
    });

    return result;
};

const decodeQuery = function(query) {
    const data = {};

    query.split("&").forEach(function(_bite) {
        const bite = _bite.trim();
        if (!bite) {
            return;
        }

        const split = bite.split("=", 2);
        if (split.length < 2) {
            split.push("");
        }

        const key = decodeURIComponent(split[0]);
        const value = decodeURIComponent(split[1]);
        if (!Container.contains(data, key)) {
            data[key] = value;
        } else if (!isArray(data[key])) {
            data[key] = [data[key], value];
        } else {
            data[key].push(value);
        }
    });

    return data;
};

const encodeQuery = function(data) {
    const queries = [];

    const pushKeyValuePair = function(queries, key) {
        key = encodeURIComponent(key);
        return function(value) {
            queries.push(key + "=" + encodeURIComponent(value));
        };
    };

    Container.forEach(data, function(_values, key) {
        const values = isArray(_values) ? _values : [_values];
        values.forEach(pushKeyValuePair(queries, key));
    });

    return queries.join("&");
};

const uriRex = /^(\w+):\/\/(?:([^\/\:\?\#]+)(\:\d+)?)?([^\?\#]+)?(\?[^\#]*)?(\#.*)?$/;

const URI = function(uri) {
    let match = uriRex.exec("" + uri);
    if (!match) {
        throw new Error("invalid URI " + uri);
    }
    match = match.slice(1, match.length).map(function(value) {
        return typeof value === "undefined" ? null : value;
    });

    this.scheme = match[0];
    this.host = match[1];
    this.path = match[3];

    let port = match[2];
    const query = match[4];
    const hash = match[5];

    if (port !== null) {
        port = Number(port.slice(1, port.length));
    }
    this.port = port;

    this.data = decodeQuery((query || "").substring(1));
    this.hash = hash === null ? null : hash.substring(1);
};

URI.prototype.getData = function() {
    return copyObject(this.data);
};

URI.prototype.setData = function(data) {
    this.data = copyObject(data);
};

URI.prototype.toString = function() {
    const host = this.host === null ? "" : this.host;
    const port = this.port === null ? "" : ":" + this.port;
    const path = this.path || "";

    let query = encodeQuery(this.data);
    if (query) {
        query = "?" + query;
    }

    const hash = this.hash === null ? "" : "#" + this.hash;

    return this.scheme + "://" + host + port + path + query + hash;
};

URI.encodeQuery = encodeQuery;
URI.decodeQuery = decodeQuery;

export default URI;



// WEBPACK FOOTER //
// ./src/abusesa-js/URI.js